import React from 'react'
import styled from 'styled-components'
import { media } from 'utils/media'
import { Text, textSize } from 'lib/Text'

const Title = styled(Text)`
  ${textSize('l')}
  ${media.phoneDown} {
    ${textSize('m')}
  }
`

interface Props {
  title: string
  className?: string
}

export const SectionHeader = ({ title, className }: Props) => (
  <Title color="black-100" as="h2" margin="1x" className={className}>
    {title}
  </Title>
)
